import { render, staticRenderFns } from "./Flags.vue?vue&type=template&id=d2b91bec&scoped=true&"
import script from "./Flags.vue?vue&type=script&lang=js&"
export * from "./Flags.vue?vue&type=script&lang=js&"
import style0 from "./Flags.vue?vue&type=style&index=0&id=d2b91bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b91bec",
  null
  
)

export default component.exports